export default __webpack_public_path__ + "static/media/informationIcon.8c0b3eb0.svg";